"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeInWords = exports.timeValue = void 0;
const numbers_1 = require("../numbers");
function timeValue({ hours, minutes, ampm }) {
    let hours24 = hours % 24;
    let hours12 = hours24 % 12;
    if (hours24 < 13 && ampm === 'pm')
        hours24 = (hours24 + 12) % 24;
    if (hours12 === 0)
        hours12 = 12;
    const amOrPm = hours24 > 12 ? 'pm' : ampm || 'am';
    const hours24Text = String(hours24).padStart(2, '0');
    const minutesText = String(minutes).padStart(2, '0');
    return {
        hours,
        minutes,
        hours24,
        hours12,
        ampm: amOrPm,
        time24Text: `${hours24Text}.${minutesText}`,
        time12Text: `${hours12}.${minutesText}`,
        time12TextAmPm: `${hours12}.${minutesText} ${amOrPm}`,
    };
}
exports.timeValue = timeValue;
function timeInWords({ hours, minutes }) {
    const hoursWords = (0, numbers_1.integerInWords)({ int: hours });
    const minutesWords = (0, numbers_1.integerInWords)({ int: minutes });
    const hoursText = minutes ? hoursWords : `${hoursWords} o'clock`;
    const minutesText = minutes ? minutesWords : '';
    return `${hoursText}${minutesText ? ' ' : ''}${minutesText && minutes < 10 ? ' o-' : ''}${minutesText}`;
}
exports.timeInWords = timeInWords;
